module.exports = __webpack_public_path__ + "img/xybjFour.65b99b28.jpg";